<template>
  <div class="border-t border-gray-20 relative" :class="[$style.root]">
    <header
      class="flex sticky top-0 z-10 border-b border-gray-20 bg-white justify-between"
    >
      <div class="flex items-center px-4">
        Totalt antal km: <strong class="pl-2">{{ totalKm }}</strong>
      </div>
      <div class="flex">
        <AppButton
          @click="$emit('center-path')"
          kind="secondary"
          size="sm"
          class="border-l border-gray-20"
        >
          <i class="material-icons text-gray-60 hover:text-gray-80">
            center_focus_weak
          </i>
        </AppButton>
        <AppButton
          @click="onClear"
          kind="secondary"
          size="sm"
          class="border-l border-gray-20"
        >
          Töm
        </AppButton>
      </div>
    </header>
    <table :class="$style.table" class="w-full">
      <thead>
        <tr class="bg-gray-20">
          <th>
            Tpl
          </th>
          <th>
            Km
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, $i) in shortestPath">
          <TrafficLocationsResultRow
            :place="item.placeStart"
            :distance="0"
            :key="$i + 'key'"
            v-if="$i === 0"
          />
          <TrafficLocationsResultRow
            :place="item.placeEnd"
            :distance="item.distance"
            :key="$i"
          />
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import TrafficLocationsResultRow from './TrafficLocationsResultRow'
import { get } from 'vuex-pathify'
const mathjs = require('mathjs')

export default {
  name: 'TrafficLocationsResultTable',

  components: {
    TrafficLocationsResultRow
  },

  computed: {
    shortestPath: get('routeLinks/shortestPath@data'),

    totalKm() {
      return mathjs
        .chain(this.shortestPath.map(x => x.distance))
        .sum()
        .done()
        .toFixed(3)
    }
  },
  methods: {
    onClear() {
      this.$store.set('routeLinks/model@from', '')
      this.$store.set('routeLinks/model@to', '')
      this.$store.set('routeLinks/model@via', '')
      this.$store.set('routeLinks/shortestPath@data', [])
      this.$emit('clear')
    }
  }
}
</script>

<style lang="postcss" module>
.table th,
.table td {
  @apply px-4 text-left;
}

.table th {
  @apply py-1 text-sm;
}

.table td {
  @apply py-2 text-gray-70 text-sm;
}

.table tbody tr {
  @apply border-b border-gray-10;
}

.root {
  overflow-y: auto;
  height: calc(100vh - 48px - 160px);
}
</style>
